// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { News } from '../interfaces/news.interface';
import { environment } from '../../environments/environment'; // Import environment
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable, firstValueFrom } from 'rxjs';
import { DataProcessingService } from './data-prcessing.service';
import { Log } from '../interfaces/logs.interface';

interface FrontendConfig {
  api_url?: string;
  version?: string;
  build?: string;
  maintenece_mode?: boolean;
  maintenece_planning?: boolean;
  maintenece_message?: string;
  maintenece_planning_time?: {
    start?: string;
    end?: string;
  };
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private apiUrl = `${environment.FrontendConfigUrl}`;
  private config: FrontendConfig | null = null;


  constructor(private http: HttpClient, private dataProcess: DataProcessingService) { }

  /// Set orginal enviroment.apiBaseUrl with this data from backend, to avoid hardcoding apiBaseUrl in environment files
  setConfig(): Observable<FrontendConfig> {
    return this.http.get<FrontendConfig>(this.apiUrl);
  }

  async loadConfig(): Promise<void> {
    try {
      const config = await firstValueFrom(this.setConfig());
      this.config = config || null;
    } catch {
      this.config = null;
    }

  }

  get apiBaseUrl(): string {
    return this.config?.api_url || environment.apiBaseUrl;
  }

  resolveApiUrl(path: string): string {
    const base = this.apiBaseUrl.replace(/\/+$/, '');
    const suffix = path.replace(/^\/+/, '');
    return `${base}/${suffix}`;
  }

  get maintenanceMode(): boolean {
    return this.config?.maintenece_mode || false;
  }

  get maintenancePlanning(): boolean {
    return this.config?.maintenece_planning || false;
  }

  get maintenanceMessage(): string | null {
    return this.config?.maintenece_message || null;
  }

  get maintenancePlanningTime(): { start?: string; end?: string } | null {
    return this.config?.maintenece_planning_time || null;
  }

  get appVersion(): string {
    return this.config?.version || environment.version;
  }

  get buildNumber(): string {
    return this.config?.build || environment.releaseDate;
  }

}